import { IconProps } from "@/core/global-data/dataInterface.data";

import React from 'react';

const NotifictionsIcon = ({ width = '24', height = '24', className = '' }: IconProps) => {
    return (
        <svg 
            width={width} 
            height={height} 
            viewBox="0 0 24 24" 
            fill="none" 
            xmlns="http://www.w3.org/2000/svg"
            className={className}
        >
            <path
                d="M18.75 9.75V8.625C18.75 5.625 16.125 3 13.125 3H10.875C7.875 3 5.25 5.625 5.25 8.625V9.75C5.25 13.125 3.75 14.25 3.75 14.25H20.25C20.25 14.25 18.75 13.125 18.75 9.75Z"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M14.625 18.75C14.625 19.3723 14.3773 19.9687 13.9371 20.4089C13.4969 20.8491 12.9005 21.0968 12.2782 21.0968C11.6559 21.0968 11.0595 20.8491 10.6193 20.4089C10.1791 19.9687 9.93137 19.3723 9.93137 18.75"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export default NotifictionsIcon;
